import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { DomainAmazon } from 'features/globalSetup/features/amazon/types/domainAmazon'
import { fromDTO } from './api/mapper'
import { GET_DOMAIN_AMAZON_ALERTS } from './api/query'
import { Props, Return } from './types'

export const useGetDomainAmazonAlerts = ({ domainAmazonId }: Props): Return => {
  const [alerts, setAlerts] = useState<DomainAmazon['alerts']>([])

  useQuery(GET_DOMAIN_AMAZON_ALERTS, {
    onCompleted: ({ node }): void => {
      if (node !== null) {
        setAlerts(fromDTO(node).alerts)
      }
    },
    variables: { id: domainAmazonId },
  })

  return { alerts }
}
